const initialState = {
    showAlert: false,
    text: ""
};

const apiAlert = (state = initialState, action) => {
    switch (action.type) {
        case 'SHOW_ALERT':
            return {...state, showAlert: true, text: action.text};
        case 'HIDE_ALERT':
            return {...state, showAlert: false, text: ""};
        default:
            return state;
    }
  };

  export default apiAlert;

  //Actions
  export const showAlert = (text) => {
    return {
        type: 'SHOW_ALERT',
        text
    };
  };

  export const hideAlert = () => {
    return {
        type: 'HIDE_ALERT'
    };
  };